<script>
    $: currentYear = new Date().getFullYear();
  </script>
  
  <footer class="footer">
    <p>
      © {currentYear}
      <a href="https://aiobfuscation.com" target="_blank">
        AI Cloaker LLC
      </a>
    </p>
    <p>
      <a href="https://aicloaker.com/privacypolicy.html" target="_blank">
        Privacy Policy
      </a>
      |
      <a href="https://aicloaker.com/termsofservice.html" target="_blank">
        Terms of Service
      </a>
    </p>
  </footer>
  
  <style>
    .footer {
      text-align: center;
      padding: 1rem;
      color: #999;
    }
    .footer a {
      color: #999;
      text-decoration: none;
    }
    .footer a:hover {
      text-decoration: underline;
    }
  </style>
  
